var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EntrySjh',{attrs:{"flow-mode":"930"}})
}
var staticRenderFns = []

export { render, staticRenderFns }